module.exports = __webpack_public_path__ + "img/arrow.8d05f212.svg";